import { createFileRoute } from "@tanstack/react-router";
import { JoinPage } from "../features/session/join-page";

export const Route = createFileRoute("/join/$code")({ component: Page });

function Page() {
	const { code } = Route.useParams();
	return <JoinPage key={code} code={code} />;
}
